// Fetch request
import fetch from '../../../core/fetch';

// Redux
import { getSearchResults, loadingSearchResults } from '../../../actions/getSearchResults';

async function submit(values, dispatch) {

  dispatch(loadingSearchResults());
  const query =
    `query(
      $personCapacity: Int,
      $dates: String,
      $currentPage: Int,
      $lat: Float,
      $lng: Float,
      $roomType: [Int],
      $bedrooms: Int,
      $bathrooms: Int,
      $beds: Int,
      $amenities: [Int],
      $spaces: [Int],
      $houseRules: [String],
      $priceRange: [Int],
      $personCapacityRange: [Int],
      $floorHeightRange: [Float],
      $flooring: String,
      $floorCount: String,
      $floorLoading: String,
      $floorHeight: Float,
      $security: String,
      $securityClass: String,
      $powerConnection: String,
      $lighting: String,
      $buildingClimate: String,
      $buildingCondition: String,
      $parkingCount: Int
      $truckDocks: Int
      $ramps: Int
      $gates: Int
      $doors: Int
      $geography: String,
      $bookingType: String,
      $geoType: String,
      $searchByMap: Boolean,
      $sw_lat: Float,
      $sw_lng: Float,
      $ne_lat: Float,
      $ne_lng: Float
    ){
      SearchListing(
        personCapacity: $personCapacity,
        dates: $dates,
        currentPage: $currentPage
        lat: $lat,
        lng: $lng,
        roomType: $roomType,
        bedrooms: $bedrooms,
        bathrooms: $bathrooms,
        beds: $beds,
        amenities: $amenities,
        spaces: $spaces,
        houseRules: $houseRules,
        priceRange: $priceRange,
        personCapacityRange: $personCapacityRange,
        floorHeightRange: $floorHeightRange,
        flooring: $flooring,
        floorCount: $floorCount,
        floorLoading: $floorLoading,
        floorHeight: $floorHeight,
        security: $security,
        securityClass: $securityClass,
        powerConnection: $powerConnection,
        lighting: $lighting,
        buildingClimate: $buildingClimate,
        buildingCondition: $buildingCondition,
        parkingCount: $parkingCount,
        truckDocks: $truckDocks,
        ramps: $ramps,
        gates: $gates,
        doors: $doors,
        geography: $geography,
        bookingType: $bookingType,
        geoType: $geoType,
        searchByMap: $searchByMap,
        sw_lat: $sw_lat,
        sw_lng: $sw_lng,
        ne_lat: $ne_lat,
        ne_lng: $ne_lng
      ) {
        count
        results {
          id
          title
          personCapacity
          floorHeight
          security
          securityClass
          lighting
          city
          state
          lat
          lng
          beds
          coverPhoto
          bookingType
          reviewsCount,
          reviewsStarRating,
          listPhotos {
            id
            name
            type
            status
          }
          listingData {
            basePrice
            currency
          }
          settingsData {
            listsettings {
              id
              itemName
              itemDescription
            }
          }
          wishListStatus
          isListOwner
        }
      }
    }
  `;



  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: query,
      variables: values
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();

  if (data && data.SearchListing) {
    dispatch(getSearchResults(data.SearchListing));
  }

}

export default submit;
